import { network } from 'services/network';

export const ENDPOINT = 'api/bo/getLargestDurationVariance';

export const getLargestDurationVariance = (params) => {
    const payload = {
        compareVersionId: params.compareVersionId,
        contractId: params.contractId,
        latestVersionId: params.latestVersionId,
        projectId: params.projectId,
        filter: params.filterData,
    };
    return network.post(ENDPOINT, payload).then((response) => {
        return response.data;
    });
};
